import '@vaadin/tooltip';
import { html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { TmBaseComponent } from '../tm-base.component';

type TooltipPosition =
    | 'top'
    | 'bottom-end'
    | 'bottom-start'
    | 'bottom'
    | 'end-bottom'
    | 'end-top'
    | 'end'
    | 'start-bottom'
    | 'start-top'
    | 'start'
    | 'top-end'
    | 'top-start';

export const tagName = 'tm-tooltip';
@customElement(tagName)
export class TmTooltip extends TmBaseComponent {
    @property({ type: String })
    public position: TooltipPosition = 'top-start';

    @property({ type: String })
    public text = '';

    @property({ type: Boolean })
    public tooltipOpened = false;

    protected render() {
        return html`${this.renderTooltipTrigger()}<vaadin-tooltip
                for="tooltip-trigger"
                .text=${this.text}
                .position=${this.position}
                ?manual=${this.tooltipOpened}
                .opened=${this.tooltipOpened}
            ></vaadin-tooltip>`;
    }

    private renderTooltipTrigger() {
        return html`<div id="tooltip-trigger">
            <slot></slot>
        </div>`;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        [tagName]: TmTooltip;
    }
}
